export enum EntityStoreKey {
  candidate = 'candidate',
}
